// extracted by mini-css-extract-plugin
module.exports = {"upn":"SearchUsers_upn__3LbgU","selected":"SearchUsers_selected__1u8Gl","menuText":"SearchUsers_menuText__3FXQN"};